import React, { useState, useEffect, useRef } from "react";
import Layout from '../form-layout'
import Step13Medicine from "../../components/selection-medicine";
import Step13Checkout from "../../components/pricing-checkout";
import Step13Dosage from "../../components/medicine-dosage";
import Step13Faq from "../../components/Faq";
import Step13Reviews from "../../components/Review";
import Step13Benefits from "../../components/benefit-us"
import Step13Contact from "../../components/contact-us";
import Step13Stripe from "../Stripe";

export default function Step13({ onNext, onBack }) {
  const [suggestedMedicine, setSuggestedMedicine] = useState([]);
  const [selectedMedicine, setSelectedMedicine] = useState(
    JSON.parse(localStorage.getItem("selectedMedicine")) || null
  );
  const [currentMiniStep, setCurrentMiniStep] = useState(0);

  // Contact validation
  const [isContactValid, setIsContactValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  // Stripe pay readiness
  const [isPayReady, setIsPayReady] = useState(false);

  // Ref for contact step to call checkOrCreateUser
  const contactRef = useRef();

  useEffect(() => {
    const medicine = localStorage.getItem("suggestedMedicine") || "";
    if (medicine === "BOTH") setSuggestedMedicine(["CAAS", "GLP-1"]);
    else if (medicine) setSuggestedMedicine([medicine]);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentMiniStep]);

  const handleMedicineSelect = (medicine) => {
    setSelectedMedicine(medicine);
    localStorage.setItem("selectedMedicine", JSON.stringify(medicine));
  };

  const miniSteps = [
    suggestedMedicine.length > 0 && (
      <Step13Medicine onSelect={handleMedicineSelect} suggestedMedicine={suggestedMedicine} />
    ),
    <Step13Checkout selectedMedicine={selectedMedicine} />,
    <Step13Dosage selectedMedicine={selectedMedicine} />,
    <Step13Benefits />,
    <Step13Faq />,
    <Step13Reviews />,
    <Step13Contact ref={contactRef} onChange={(valid) => setIsContactValid(valid)} />,
    <Step13Stripe selectedMedicine={selectedMedicine}
      setLoading={setLoading}
      setMessage={setMessage}
    />,
  ].filter(Boolean);

  const isStripeStep = currentMiniStep === miniSteps.length - 1;

  // Poll Stripe form readiness
  useEffect(() => {
    if (!isStripeStep) return;

    const interval = setInterval(() => {
      setIsPayReady(window.stripePayReady || false);
    }, 200);

    return () => clearInterval(interval);
  }, [isStripeStep]);

  const handleNext = async () => {
    // Stripe step
    if (isStripeStep) {
      if (!isPayReady) return;
      const success = await window.stripePay();
      if (success) onNext();
      return;
    }

    // Contact step
    const currentStepComponent = miniSteps[currentMiniStep].type;
    if (currentStepComponent === Step13Contact) {
      if (!isContactValid) return;
      const success = await contactRef.current.checkOrCreateUser();
      if (!success) return;
    }

    // Move to next mini-step
    setCurrentMiniStep(currentMiniStep + 1);
  };

  const isNextDisabled =
    (miniSteps[currentMiniStep].type === Step13Contact && !isContactValid) ||
    (isStripeStep && !isPayReady);

  return (
    <Layout
      onBack={() => {
        if (currentMiniStep === 0) return onBack(); 
        setCurrentMiniStep(currentMiniStep - 1); 
      }}
    >
      <div className="max-w-3xl px-4 py-10">
        {miniSteps[currentMiniStep]}

        <div className="mt-10 flex justify-start">
          <button
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors ${isNextDisabled
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
            onClick={handleNext}
            disabled={isNextDisabled}
          >
            {isStripeStep ? "Pay" : "Next"}
          </button>
        </div>
      </div>
    </Layout>
  );
}
